if (typeof StepsShowcase !== 'function') {
  class StepsShowcase extends HTMLElement {
    constructor() {
      super();
      this.dots = this.querySelectorAll('.js-steps-dot');
      this.slides = this.querySelectorAll('.js-steps-slide');
      this.stepTexts = this.querySelectorAll('.js-step-text');
      this.pauseBtn = this.querySelector('.js-steps-pause');
      this.resetBtn = this.querySelector('.js-steps-reset');

      this.index = 0;
      this.timeout = null;
      this.isPaused = false;
      this._autoplayEnabled = this.dataset.autoplay === 'true';
      this._interval = parseInt(this.dataset.autoplayTimer) * 1000 || 5000;

      this._bindEvents();
      this._updateState();

      if (this._autoplayEnabled && this.dots.length > 1) {
        this._startAutoplay();
      }
    }

    _bindEvents() {
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          if (i !== this.index) {
            this._goTo(i);
            if (this._autoplayEnabled && !this.isPaused) {
              this._restartAutoplay();
            }
          }
        });
      });

      this.stepTexts.forEach((text, i) => {
        text.addEventListener('click', () => {
          if (i !== this.index) {
            this._goTo(i);
            if (this._autoplayEnabled && !this.isPaused) {
              this._restartAutoplay();
            }
          }
        });
      });

      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', () => {
          this.isPaused = !this.isPaused;
          this.classList.toggle('is-paused', this.isPaused);
          this.pauseBtn.querySelector('.js-icon-pause').style.display = this.isPaused ? 'none' : 'block';
          this.pauseBtn.querySelector('.js-icon-play').style.display = this.isPaused ? 'block' : 'none';
          if (this.isPaused) {
            clearTimeout(this.timeout);
          } else {
            this._startAutoplay();
          }
        });
      }

      if (this.resetBtn) {
        this.resetBtn.addEventListener('click', () => {
          this._goTo(0);
          if (this._autoplayEnabled) {
            this.isPaused = false;
            this.classList.remove('is-paused');
            if (this.pauseBtn) {
              this.pauseBtn.querySelector('.js-icon-pause').style.display = 'block';
              this.pauseBtn.querySelector('.js-icon-play').style.display = 'none';
            }
            this._restartAutoplay();
          }
        });
      }
    }

    _goTo(newIndex) {
      this.index = newIndex;
      this._updateState();
    }

    _updateState() {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === this.index);
      });

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === this.index);
      });

      this.stepTexts.forEach((text, i) => {
        text.classList.remove('is-active', 'is-past', 'is-upcoming');
        if (i === this.index) {
          text.classList.add('is-active');
        } else if (i < this.index) {
          text.classList.add('is-past');
        } else {
          text.classList.add('is-upcoming');
        }
      });
    }

    _startAutoplay() {
      this.timeout = setTimeout(() => {
        const next = (this.index + 1) % this.dots.length;
        this._goTo(next);
        this._startAutoplay();
      }, this._interval);
    }

    _restartAutoplay() {
      clearTimeout(this.timeout);
      this._startAutoplay();
    }
  }

  if (typeof customElements.get('steps-showcase') === 'undefined') {
    customElements.define('steps-showcase', StepsShowcase);
  }
}